<template>
  <div class="container flex bodybg" style="margin-bottom: 30px;">
    <div class="bg-white">
      <left></left>
    </div>
    <div class="live bg-white flex1" style="margin-left: 20px;">
    			<div class="title">
    				公告
    			</div>
    			<div class="content" style="padding: 20px;line-height: 1.8;" v-html="noticesContent">

    			</div>
    		</div>
  </div>
</template>

<script>
  import left from './accountleft.vue'
  export default {
    name: 'Footer',
    components:{
      left
    },
    data () {
      return {
          showLogin:false,
          noticesTitle:'',
          noticesContent:''
      }
    },
    methods:{
      getData(){
        this.$axios.get(this.$common.notciceDetail_url+'?noticesId='+this.$route.query.id).then((res)=>{
              if(res.data.code==1){
                  this.noticesTitle=res.data.data.noticesTitle;
                  this.noticesContent=res.data.data.noticesContent
              }
              else {
                alert(res.data.msg)
              }
        })
      }
    },
    created() {
      this.getData();
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/notice.vue